import React from 'react';
import ReqTechListContainer from '../../containers/reqtechmng/ReqTechListContainer';

const ReqTechListPage = () => {
  return <ReqTechListContainer />;
};

export default ReqTechListPage;
